import type { FC } from 'react';

import {
  ARTICLE_PAGE,
  KNOWLEDGE_SEARCH_PAGE,
  WORKFLOWS_PAGE,
} from 'constants/pageConsts';
import ArticlePage from 'components/ArticlePage';
import WorkflowsPage from 'components/WorkflowsPage/WorkflowsPage';
import { KnowledgeSearchPage } from 'components/KnowledgeSearchPage/KnowledgeSearchPage';

interface PageDict {
  [key: string]: {
    component: FC<React.PropsWithChildren<Record<string, unknown>>>;
    headerName?: string;
  };
}

const pageDict: PageDict = {
  [ARTICLE_PAGE]: {
    component: ArticlePage,
    headerName: 'Back to Chat',
  },

  [KNOWLEDGE_SEARCH_PAGE]: {
    component: KnowledgeSearchPage,
    headerName: 'Back to Chat',
  },

  [WORKFLOWS_PAGE]: {
    component: WorkflowsPage,
  },
};

export { pageDict };
